export default __webpack_public_path__ + "static/media/misc-drawerA-1920w.28762d16.webp";